import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";

const DeleteConfirmModal = ({ open, onClose, onConfirm, featureName }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          animation: open ? "slideUp 0.3s ease-out" : "none",
          "@keyframes slideUp": {
            from: {
              opacity: 0,
              transform: "translateY(20px)",
            },
            to: {
              opacity: 1,
              transform: "translateY(0)",
            },
          },
        },
      }}
    >
      <DialogTitle sx={{ fontSize: "15px", fontWeight: 600 }}>
        Confirm Remove
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: "13px", color: "#6C757D" }}>
          Are you sure you want to remove the feature "{featureName}"? This
          action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          startIcon={<DeleteIcon />}
        >
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmModal;
